import type { PermissionsLiveKitOptions } from './permissions-live-kit.hook'

import { useLessonRoomStore } from './store'
import { usePermissionsLiveKit } from './permissions-live-kit.hook'
import { trackMediaPermissionError } from '../lib/classroom'

interface UseClassroomPermissionsLiveKitReturn {
  requestPermissions: () => Promise<void>
}

export const useClassroomPermissionsLiveKit = (): UseClassroomPermissionsLiveKitReturn => {
  const lessonRoomStore = useLessonRoomStore()

  const options: PermissionsLiveKitOptions = {
    permissions: {
      setDeniedMic: (v) => lessonRoomStore.setDeniedMic(v),
      setDeniedCam: (v) => lessonRoomStore.setDeniedCam(v),
      setBlocked: (v) => lessonRoomStore.setPermissionsBlocked(v),
    },
    analytics: {
      permissionsPopUp: (statuses) => trackMediaPermissionError('permissions_check', statuses),
    },
  }

  return usePermissionsLiveKit(options)
}
